import { useState } from "react";
import { Box } from "@mui/material";
import { COLORS, SHADOWS, FONTS } from "app/views/dashboard/shared/tokens";
import AddressContact from "./employee-details/AddressContact";
import BankDetails from "./employee-details/BankDetails";
import SkillsDetails from "./employee-details/SkillsDetails";
import EducationDetails from "./employee-details/EducationDetails";
import DocumentsTab from "./employee-details/DocumentsTab";
import ExperienceDetails from "./employee-details/ExperienceDetails";

const T = {
  bg: COLORS.background,
  surface: COLORS.surface,
  cardBorder: COLORS.cardBorder,
  gradient: COLORS.gradient,
  ink: COLORS.ink,
  body: COLORS.body,
  body2: COLORS.body2,
  muted: COLORS.muted,
  tabActive: SHADOWS.tabActive,
  heading: FONTS.heading,
  body_f: FONTS.body,
};

const TABS = [
  { label: "Bank Details", Component: BankDetails },
  { label: "Address & Contact", Component: AddressContact },
  { label: "Skills", Component: SkillsDetails },
  { label: "Experience", Component: ExperienceDetails },
  { label: "Education", Component: EducationDetails },
  { label: "Documents", Component: DocumentsTab },
];

export default function EmployeProfileTab() {
  const [value, setValue] = useState(0);
  const ActiveComponent = TABS[value].Component;

  return (
    <Box sx={{ background: T.bg, minHeight: "100vh" }}>
      <Box sx={{ padding: "26px 30px 44px", fontFamily: T.body_f, color: T.ink, maxWidth: 1100, margin: "0 auto", "@media (max-width:640px)": { padding: "20px 16px" } }}>
        {/* Header */}
        <Box sx={{ mb: "20px" }}>
          <h1 style={{ fontFamily: T.heading, fontSize: 26, margin: "0 0 5px", fontWeight: 600, letterSpacing: "-0.015em", color: T.ink }}>
            My profile
          </h1>
          <p style={{ margin: 0, fontSize: "14px", color: T.body2 }}>Keep your personal, banking and document records up to date.</p>
        </Box>

        {/* Tabs */}
        <Box
          role="tablist"
          aria-label="Profile sections"
          sx={{
            display: "flex",
            gap: "4px",
            background: T.surface,
            border: `1px solid ${T.cardBorder}`,
            borderRadius: "12px",
            padding: "4px",
            mb: "18px",
            overflowX: "auto",
            "&::-webkit-scrollbar": { height: 0 },
          }}
        >
          {TABS.map((tab, i) => (
            <Box
              key={tab.label}
              component="button"
              type="button"
              role="tab"
              aria-selected={value === i}
              onClick={() => setValue(i)}
              sx={{
                border: "none",
                whiteSpace: "nowrap",
                flexShrink: 0,
                fontFamily: T.body_f,
                fontSize: "13px",
                fontWeight: value === i ? 600 : 500,
                padding: "9px 15px",
                borderRadius: "9px",
                cursor: "pointer",
                background: value === i ? T.gradient : "transparent",
                color: value === i ? "#fff" : T.body2,
                boxShadow: value === i ? T.tabActive : "none",
                transition: "all 0.15s",
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        {/* Active panel */}
        <Box role="tabpanel">
          <ActiveComponent />
        </Box>
      </Box>
    </Box>
  );
}
